import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { getOwnChildBranches, getNonMovementFilterData, getBranchConfig } from '../../../store/reports/reports_action'
import { connect } from 'react-redux'
import DropDownOA from '../../common/dropDownOA'
import {
  appendToUrl,
  buildCompositeFields,
  focusElemnt,
  getLocalData,
  isEmpty,
  navigation3,
  removeDuplicatesFromArray,
} from '../../common/helper'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import { ReportHeading } from './common/ReportHeading'
import * as id from './reportId'
import * as lb from './reportLables'
import {
  includingCrossing,
  summaryReport,
  crossingTransactions,
  nmrDays,
  MovementReportView,
  showTransaction,
  urls,
  detailedReport,
  excludingCrossing,
} from '../../common/constants'
import Datepicker from '../../common/datePicker'
import DropDown from '../../common/dropDown'
import DropDownMultiSelect from '../../common/dropDownMultiSelect'
import { GetRequest } from '../../common/api'
import { updateLoader, updateModal } from '../../../store/common/common_action'
import * as url from './oldReportsUrls'
import Alert from '../../common/alert'
import ManageColumns from '../../common/ManageColumnsUI'
import * as mdt from '../../common/modaltypes'
import {
  branchWiseSummary,
  branchwisePendingDispatchSummary,
  destinationWisePendingDispatchSummary,
  gtBookedReceivedPendingSummary,
  nonMovementFilter,
  nonMovementHeader,
  paymentWiseSummary,
  statusWiseSummary,
} from './NonMovementTable/NonMovementConstant'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom, useSetAtom } from 'jotai'
import { paymentModesWithAll, paytypes, TOPAY_COD_RULE, TOPAY_COD_RULE2 } from '../../common/paymentsMode'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import {
  branchSummaryData,
  branchwisePendingDispatchSummaryData,
  destinationWisePendingDispatchSummaryData,
  gtBookedReceivedPendingSummaryData,
  cityWiseGroup,
  paymentSummaryData,
  statusWiseSummaryData,
} from './NonMovementTable/utilFucntions'
import { GT_COMPANY_ID, GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../helpers/useTokens'
import { downloadPDF } from '../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../common/loginDecode'

const NonMovementReport = (props) => {
  const {
    data: { common, reports },
    getNonMovementFilterData,
    getBranchConfig,
  } = props

  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const [modal, setModal] = useAtom(modalAtom)
  const { branchListConfig } = reports
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [finYearsOpt, setFinYearsOpt] = useState([])
  const [selState, setSelState] = useState('')
  const [selCity, setSelCity] = useState('')
  const [selBranch, setSelBranch] = useState('')
  const [selReportView, setselReportView] = useState(MovementReportView[1])
  const [selReportOpt, setSelReportOpt] = useState(detailedReport[0])
  const [selCrossingTrans, setSelCrosssingTrans] = useState(crossingTransactions[1])
  const [selLRStatus, setSelLRStatus] = useState(excludingCrossing[0])
  const [nmDays, setNmDays] = useState(4)
  const [selTransaction, setSelTransaction] = useState(showTransaction[1])
  const [isBranchWise, setIsBranchWise] = useState(false)
  const [selfinancialYear, setSelfinancialYear] = useState()
  const [tableData, setTableData] = useState([])
  const [showReport, setShowReport] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [filterData, setFilterData] = useState({
    FromDate: '',
    ToDate: '',
    reportOption: '',
    stateName: '',
    cityName: '',
    BranchName: '',
    transaction: '',
    payment: '',
    crossingTrans: '',
    ReportTypeId: '',
    ReportTypeName: '',
    reportOptionId: '',
    financialYear: '',
    paymentTypeId: '',
    paymentTypeName: '',
    crossingTransactions: '',
    crossingTransactionsID: '',
    Status: '',
    IncludeDate: false,
    dataType: 'entry',
  })
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: '',
  })

  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [nonMoveFilterData, setNonMoveFilterData] = useState([])
  const reportName = 'Non - Movement'

  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowExportExcel } = { ...roleRightsData }
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD || 0
  const UseFormattedLRinReports = companySettings[0]?.UseFormattedLRinReports || 0
  const NonMovementPortrait = companySettings[0]?.IsNonMovementPortrait || 0
  const disableExcel = !AllowExportExcel

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }
  const { intCompanyID, intUserID, IsAdmin, intBranchID, strCompanyName, IsBranchAdmin, IsMTPLAdmin } = loginData
  const isGtCompany = Number(intCompanyID) === GT_COMPANY_ID
  const includingCrossingLocal = Number(intCompanyID) === GUJRAT_COMPANY_ID
    ? includingCrossing.map((item) =>
        item.id === 'BRW' ? { ...item, name: 'Current Branch wise pending dispatch' } : item
      )
    : includingCrossing
  const brwOption = includingCrossingLocal.find((item) => String(item.id).toUpperCase() === 'BRW')
  const dwOption = includingCrossingLocal.find((item) => String(item.id).toUpperCase() === 'DW')
  const summaryReportOptions = isGtCompany
    ? [...summaryReport, { id: 4, name: 'Current Branch Wise' }, { id: 5, name: 'Destination Wise Pending Dispatch' }]
    : summaryReport
  const isCurrentBranchWiseSummary =
    isGtCompany && Number(selReportView?.id) === 0 && Number(selReportOpt?.id) === 4
  const isDestinationWiseSummary =
    isGtCompany && Number(selReportView?.id) === 0 && Number(selReportOpt?.id) === 5
  const isLockedPendingDispatchSummary = isCurrentBranchWiseSummary || isDestinationWiseSummary

  const isBookedReceivedPendingDispatch = (status = selLRStatus) =>
    ['BR', 'BRW'].includes(String(status?.id).toUpperCase())
  const isBranchwisePendingDispatch = (status = selLRStatus) =>
    String(status?.id).toUpperCase() === 'BRW' ||
    String(status?.name).toLowerCase() === 'branchwise pending dispatch' ||
    String(status?.name).toLowerCase() === 'current branch wise pending dispatch'
  const isDestinationWisePendingDispatch = (status = selLRStatus) =>
    String(status?.id).toUpperCase() === 'DW' ||
    String(status?.name).toLowerCase() === 'destination wise pending dispatch'
  const isSummaryPaymentTypeWise = Number(selReportView?.id) === 0 && ![3, 4, 5].includes(Number(selReportOpt?.id))
  const baseLrStatusOptions =
    selCrossingTrans.id == 1 || isLockedPendingDispatchSummary ? includingCrossingLocal : excludingCrossing
  const lrStatusOptions = baseLrStatusOptions.filter((item) => {
    const statusId = String(item.id).toUpperCase()
    if (statusId === 'DW') return isGtCompany && isDestinationWiseSummary
    if (statusId !== 'BRW') return true
    if (isGtCompany) return isCurrentBranchWiseSummary
    return !isSummaryPaymentTypeWise
  })
  const shouldShowGtBRChangeSummary = () =>
    Number(intCompanyID) === GT_COMPANY_ID &&
    Number(selReportView?.id) === 0 &&
    Number(selReportOpt?.id) === 3 &&
    isBookedReceivedPendingDispatch() &&
    !isBranchwisePendingDispatch() &&
    !isDestinationWisePendingDispatch()

  const updatedPaymentModes = !UseToPayAsCOD
    ? paymentModesWithAll
    : paymentModesWithAll
      .map((item) => {
        if (item.typeId === paytypes.COD) return null
        const codName = TOPAY_COD_RULE[item.typeId]
        return codName ? { ...item, name: codName } : item
      })
      .filter(Boolean)

  useEffect(() => {
    const statusId = String(selLRStatus?.id).toUpperCase()
    if (isSummaryPaymentTypeWise && ['BRW', 'DW'].includes(statusId)) {
      setSelLRStatus(includingCrossingLocal[0])
    }
  }, [isSummaryPaymentTypeWise, selLRStatus?.id])

  const [selPaymentType, setSelPaymentType] = useState(updatedPaymentModes)
  const company10BRHiddenStatusFields = [
    'totalLRD',
    'totalUnitD',
    'totalNetAmtD',
    'totalLRDR',
    'totalUnitDR',
    'totalNetAmtDR',
  ]
  const shouldHideCompany10BRStatusSummaryColumns = (reportViewId, reportOptionId, lrStatusId, lrStatusName) => {
    const isBookedReceivedPendingDispatch =
      String(lrStatusId).toUpperCase() === 'BR' ||
      String(lrStatusName).toLowerCase() === 'booked & received but pending dispatch'

    return [GT_COMPANY_ID].includes(Number(intCompanyID)) &&
      Number(reportViewId) === 0 &&
      Number(reportOptionId) === 3 &&
      isBookedReceivedPendingDispatch
  }
  const getStatusWiseSummaryHeaders = (hideColumns) =>
    hideColumns
      ? statusWiseSummary
      .map((item) => {
        if (!Array.isArray(item.children)) return item
        const children = item.children.filter((child) => !company10BRHiddenStatusFields.includes(child.field))
        return { ...item, children, colSpan: children.length }
      })
      .filter((item) => !Array.isArray(item.children) || item.children.length > 0)
      : statusWiseSummary
  const statusWiseSummaryHeaders = getStatusWiseSummaryHeaders(
    shouldHideCompany10BRStatusSummaryColumns(selReportView?.id, selReportOpt?.id, selLRStatus?.id, selLRStatus?.name)
  )
  const statusWiseSummaryDefs = statusWiseSummaryHeaders.flatMap((item) => {
    if (!Array.isArray(item.children)) {
      return {
        ...item,
        align: 'left',
      }
    }
    return item.children.map((child) => ({
      ...child,
      align: 'right',
    }))
  })
  const branchWiseSummaryDefs = branchWiseSummary.map((item) => ({
    ...item,
    align: item.align ? item.align : item?.xlCol?.dataType === 'quantity' ? 'right' : undefined,
  }))

  const paymentWiseSummaryDefs = paymentWiseSummary(intCompanyID)
    .map((item) => {
      const res = {
        ...item,
        align: item.align ? item.align : item?.xlCol?.dataType === 'quantity' ? 'right' : undefined,
      }
      if (DefaultCurrencyID === 2) {
        if (item.field === 'TotalValuation') {
          res.headerName = 'Insurance\nChrg.'
          res.exportHead = 'Insurance\nChrg.'
        }
        if (item.field === 'ServiceTaxAmount') {
          return false
        }
      }
      return res
    })
    .filter(Boolean)

  const resolveHeaders = (viewId, optId) => {
    if (viewId === 1) {
      return manageColumn.filter((obj) => obj.isSelected)
    }
    if (optId === 1) return paymentWiseSummaryDefs
    if (optId === 2) return branchWiseSummaryDefs
    if (optId === 3) return statusWiseSummaryDefs
    return []
  }
  useEffect(() => {
    const updateColumnDetails = async () => {
      let commonHeader = ''
      let localBrnhTransfCol = await getLocalData('LRWiseDetailsStatusReport339')
      if (localBrnhTransfCol) {
        commonHeader = localBrnhTransfCol
      } else {
        commonHeader = nonMovementHeader(intCompanyID)
      }
      if (UseFormattedLRinReports !== 3) {
        commonHeader = commonHeader.filter((item) => item.field !== 'FormattedLRNO')
      }
      if (NonMovementPortrait === 1) {
        commonHeader = commonHeader.filter((item) => item.isMandatory)
      }
      if (DefaultCurrencyID === 2) {
        commonHeader = commonHeader
          .filter((col) => col.field !== 'ServiceTaxAmount')
          .map((col) => {
            if (col.field === 'Valuation') {
              return { ...col, header: 'Insu.\nChrg.', exportHead: 'Insu.\nChrg.' }
            }
            return col
          })
      }
      setManageColumn(commonHeader)
    }
    updateColumnDetails()
  }, [UseFormattedLRinReports, NonMovementPortrait])
  const handleClick1 = () => {
    if (selReportOpt.id === 3) {
      setShowAlert({ show: true, message: 'Status wise summary not available in Old Format' })
    } else if (selState === '' || selState === ' ') {
      setShowAlert({ show: true, message: 'Please select State' })
    } else if (selCity === '' || selCity === ' ') {
      setShowAlert({ show: true, message: 'Please select City' })
    } else if (selBranch === '' || selBranch === ' ') {
      setShowAlert({ show: true, message: 'Please select Branch' })
    } else if (selPaymentType.length == 0) {
      setShowAlert({ show: true, message: 'Please select Payment Type' })
    } else {
      let baseUrl = url.nonMovementReport
      const urlData = url.nonMovementReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDate = fromDate.format('YYYY-MM-DD')
      urlData.ToDate = toDate.format('YYYY-MM-DD')
      urlData.intCompanyId = intCompanyID
      urlData.intBranchId = selBranch.CurrentBranchID
      urlData.intUserID = intUserID
      urlData.intTimeNotMovedSince = nmDays
      urlData.AllowViewAllReport = AllowViewAllBranchReport
      urlData.IncludeDate = isBranchWise ? 1 : 0
      urlData.StatusCode = isBookedReceivedPendingDispatch() ? 'BR' : selLRStatus.id
      urlData.Status = selLRStatus.name
      urlData.SelectBranchName = selBranch?.CurrentBranch || ''
      urlData.intIsDays = 1
      urlData.intDaysOrHours = nmDays
      urlData.IsSummary = selReportView.id === 1 ? 0 : 1
      urlData.IsBranchSummary = selReportOpt.id === 2 && selReportView.id === 0 ? 1 : 0
      urlData.FinYrID = isBranchWise ? 0 : selfinancialYear.id
      urlData.IsTranDtWise = selTransaction.id
      urlData.IsOnlyExpressParcel = 2
      urlData.IsPaymentWise = selPaymentType.length == updatedPaymentModes.length ? 0 : 1
      urlData.strPayTypeID =
        selPaymentType.length != updatedPaymentModes.length
          ? selPaymentType
            .reduce((data, obj) => {
              if (obj.typeId !== 0) {
                data.push(obj.typeId)
              }
              return data
            }, [])
            .join(',')
          : ''
      urlData.intAllowExportToExcel = 1
      urlData.isV2 = 4
      baseUrl = appendToUrl(baseUrl, urlData)
      window.open(baseUrl, '_blank')
    }
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intUserID: intUserID,
        intCompanyID: intCompanyID,
        intBranchID: intBranchID,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1,
      }
      getBranchConfig(body)
    }
  }, [intUserID])
  const handleFilterData = () => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > 31 * 24 * 60 * 60 * 1000 && isBranchWise) {
      setShowAlert({ show: true, message: 'This report cannot be taken for more than 31 days' })
    } else {
      const body = {
        CompanyID: intCompanyID,
        UserID: intUserID,
        intFinYr: selfinancialYear.id,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        IncludeDate: isBranchWise ? 1 : 0,
        IsTranDtWise: selTransaction.id,
      }
      getNonMovementFilterData(body).then((val) => {
        setNonMoveFilterData([])
        if (val.status == 'Success') {
          if (val.Data.Table.length > 0) {
            val.Data.Table.forEach((obj) => {
              if (
                obj.CurrentBranchID === branchListConfig.BranchID &&
                obj.CurrentStateID == branchListConfig.StateID &&
                obj.CurrentCityID === branchListConfig.CityID
              ) {
                setSelBranch(obj)
                setSelCity(obj)
                setSelState(obj)
              }
            })
            setNonMoveFilterData(val.Data.Table)
          }
        }
      })
    }
  }
  const handleStateChange = (val) => {
    setSelState(val)
    setSelCity({ CurrentCity: 'All City', CurrentCityID: 0 })
    setSelBranch({ CurrentBranch: 'All Branch', CurrentBranchID: 0 })
  }
  const handleCityChange = (val) => {
    setSelCity(val)
    setSelBranch({ CurrentBranch: 'All Branch', CurrentBranchID: 0 })
  }
  const generateNonMovementReport = async (isPdf = false) => {
    setTableData([])
    setIsPdfLoading(false)
    setShowReport(false)
    if (selState === '' || selState === ' ') {
      setShowAlert({ show: true, message: 'Please select State' })
    } else if (selCity === '' || selCity === ' ') {
      setShowAlert({ show: true, message: 'Please select City' })
    } else if (selBranch === '' || selBranch === ' ') {
      setShowAlert({ show: true, message: 'Please select Branch' })
    } else if (selPaymentType.length == 0) {
      setShowAlert({ show: true, message: 'Please select Payment Type' })
    } else {
      const isAllSelected = selPaymentType.length === updatedPaymentModes.length
      setFilterData({
        ...filterData,
        paymentTypeName: isAllSelected ? 'All Payment' : selPaymentType.map((item) => item.name).join(','),
        ReportTypeId: selReportView.id,
        ReportTypeName: selReportView.name,
        reportOptionId: selReportOpt.id,
        reportOption: selReportOpt.name,
        stateName: selState?.CurrentStateName,
        BranchName: selBranch?.CurrentBranch,
        cityName: selCity?.CurrentCity,
        FromDate: fromDate.format('DD-MMM-YY'),
        ToDate: toDate.format('DD-MMM-YY'),
        IncludeDate: isBranchWise,
        crossingTransactions: crossingTransactions[0].name,
        crossingTransactionsID: crossingTransactions[0].id,
        Status: selLRStatus.name,
        financialYear: isBranchWise ? '-' : selfinancialYear?.name,
      })
      const strPayTypeID = isAllSelected ? '' : selPaymentType.map((item) => item.typeId).join(',')
      const body = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intBranchID: selBranch.CurrentBranchID,
        intTimeNotMovedSince: nmDays,
        AllowViewAllReport: AllowViewAllBranchReport,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        IncludeDate: isBranchWise ? 1 : 0,
        StatusCode: isDestinationWiseSummary ? 'R' : isBookedReceivedPendingDispatch() ? 'B' : selLRStatus.id,
        intIsDays: 1,
        CityID: selCity.CurrentCityID,
        StateID: selState.CurrentStateID,
        intFinYr: isBranchWise ? 0 : selfinancialYear.id,
        IsTranDtWise: selTransaction.id,
        IsOnlyExpressParcel: 2,
        IsPaymentWise: isAllSelected ? 0 : 1,
        strPayTypeID,
      }
      if (selPaymentType.length == updatedPaymentModes.length) {
        delete body.strPayTypeID
      }
      const resp = await getNonMovementData(body)
      if (isBookedReceivedPendingDispatch()) {
        body.StatusCode = 'R'
        let resp1 = await getNonMovementData(body)
        fromatData(resp, resp1, isPdf)
      } else {
        fromatData(resp, [], isPdf)
      }

    }
  }
  const fromatData = (reportData, reportDat1, isPdf = false) => {
    const isAllSelected = selPaymentType.length === updatedPaymentModes.length

    const criteriaData = {
      paymentTypeName: isAllSelected ? 'All Payment' : selPaymentType.map((item) => item.name).join(','),
      ReportTypeId: selReportView.id,
      ReportTypeName: selReportView.name,
      reportOptionId: selReportOpt.id,
      reportOption: selReportOpt.name,
      stateName: selState?.CurrentStateName,
      BranchName: selBranch?.CurrentBranch,
      cityName: selCity?.CurrentCity,
      FromDate: fromDate.format('DD-MMM-YY'),
      ToDate: toDate.format('DD-MMM-YY'),
      IncludeDate: isBranchWise,
      crossingTransactions: crossingTransactions[0].name,
      crossingTransactionsID: crossingTransactions[0].id,
      Status: selLRStatus.name,
      StatusCode: selLRStatus.id,
      financialYear: isBranchWise ? '-' : selfinancialYear?.name,
      dataType: 'entry',
    }
    let criteriaHeaders = nonMovementFilter.map((obj) => ({
      ...obj,
      field: obj.dataKey,
      textAlign: obj.xlCol.dataType === 'quantity' ? 'right' : "left",
    }))
    const selectedStatusWiseHeaders = getStatusWiseSummaryHeaders(
      shouldHideCompany10BRStatusSummaryColumns(
        criteriaData.ReportTypeId,
        criteriaData.reportOptionId,
        criteriaData.StatusCode,
        criteriaData.Status
      )
    )
    if (isBranchwisePendingDispatch() && !isSummaryPaymentTypeWise) {
      const summarySourceData = [...reportData, ...reportDat1]

      if (summarySourceData.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }

      const columnDefs = (intCompanyID === GUJRAT_COMPANY_ID ? branchwisePendingDispatchSummary : branchwisePendingDispatchSummary.filter((item) => item.field !== 'DestinationCity')).map((obj) => ({
        ...obj,
        align: obj.xlCol.dataType === 'quantity' ? 'right' : 'left',
        weight: obj.field === 'SourceDestinationBranch' ? 360 : 140,
        header: intCompanyID === GUJRAT_COMPANY_ID && obj.field === 'SourceDestinationBranch' ? 'Current Branch - Destination Branch' : obj.header,
        exportHead: intCompanyID === GUJRAT_COMPANY_ID && obj.field === 'SourceDestinationBranch' ? 'Current Branch - Destination Branch' : obj.exportHead,
        export: intCompanyID === GUJRAT_COMPANY_ID && obj.field === 'SourceDestinationBranch' ? 'Current Branch - Destination Branch' : obj.exportHead,
      }))
      const mainReportData = branchwisePendingDispatchSummaryData(reportData, reportDat1,intCompanyID === GUJRAT_COMPANY_ID ? 'CurrentBranch' : 'BookingBranch')
      if (isPdf === true) {
        downloadPDF({
          reportName,
          criteriaHeaders: criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: mainReportData,
          visibleColumns: columnDefs,
          loginData,
          showColumnBorders: true,
        })
        return
      }
      const reportPayload = {
        reportName,
        isMultiTable: true,
        tables: [
          {
            reportName: 'Booked but Pending Disp + Received but Pending Disp',
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: mainReportData,
            mainHeader: columnDefs,
            serialNokey: '',
          },
        ],
        hideHeader: false,
        showColumnBorders: true,
        isIncreFontSize: true,
        minTableWidth: '620px',
      }
      const rid = Date.now().toString()

      if (!window.generatedReports) {
        window.generatedReports = {}
      }

      window.generatedReports[rid] = reportPayload
      window.open(`/view-report?rid=${rid}`, "_blank")
      return
    }
    if (isDestinationWisePendingDispatch() && isDestinationWiseSummary) {
      const summarySourceData = reportData
      const columnDefs = destinationWisePendingDispatchSummary.map((obj) => ({
        ...obj,
        align: obj.xlCol.dataType === 'quantity' ? 'right' : 'left',
        weight: obj.field === 'DestinationBranch' || obj.field === 'BranchName' ? 220 : 140,
        export: obj.exportHead,
      }))
      const mainReportData = destinationWisePendingDispatchSummaryData(summarySourceData)

      if (!summarySourceData.length || !mainReportData.length) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }
      if (isPdf === true) {
        downloadPDF({
          reportName,
          criteriaHeaders: criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: mainReportData,
          visibleColumns: columnDefs,
          loginData,
          showColumnBorders: true,
        })
        return
      }
      const reportPayload = {
        reportName,
        isMultiTable: true,
        tables: [
          {
            reportName: 'Destination Wise pending dispatch',
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: mainReportData,
            mainHeader: columnDefs,
            serialNokey: '',
          },
        ],
        hideHeader: false,
        showColumnBorders: true,
        isIncreFontSize: true,
        minTableWidth: '620px',
      }
      const rid = Date.now().toString()

      if (!window.generatedReports) {
        window.generatedReports = {}
      }

      window.generatedReports[rid] = reportPayload
      window.open(`/view-report?rid=${rid}`, "_blank")
      return
    }
    if (shouldShowGtBRChangeSummary()) {
      const summarySourceData = [...reportData, ...reportDat1]

      if (summarySourceData.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }

      const columnDefs = gtBookedReceivedPendingSummary.map((obj) => ({
        ...obj,
        export: obj.exportHead,
        align: obj.xlCol.dataType === 'quantity' ? 'right' : 'left',
        weight: ['SourceBranch', 'CurrentBranchName', 'DestinationBranchName'].includes(obj.field) ? 180 : 80,
      }))
      const mainReportData = gtBookedReceivedPendingSummaryData(reportData, reportDat1)
      if (isPdf === true) {
        downloadPDF({
          reportName,
          criteriaHeaders: criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: mainReportData,
          visibleColumns: columnDefs,
          loginData,
          showColumnBorders: true,
        })
        return
      }
      const reportPayload = {
        reportName,
        isMultiTable: true,
        tables: [
          {
            reportName: 'Booked & Recived But Pending Dispatch',
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: mainReportData,
            mainHeader: columnDefs,
            serialNokey: '',
          },
        ],
        hideHeader: true,
        showColumnBorders: true,
        isIncreFontSize: true,
        minTableWidth: '1100px',
      }
      const rid = Date.now().toString()

      if (!window.generatedReports) {
        window.generatedReports = {}
      }

      window.generatedReports[rid] = reportPayload
      window.open(`/view-report?rid=${rid}`, "_blank")
      return
    }
    let mainReportData = []
    let columnDefs = Number(selReportOpt.id) === 3 && Number(selReportView.id) === 0
      ? selectedStatusWiseHeaders.flatMap((item) => {
        if (!Array.isArray(item.children)) {
          return {
            ...item,
            align: 'left',
          }
        }
        return item.children.map((child) => ({
          ...child,
          align: 'right',
        }))
      })
      : resolveHeaders(selReportView.id, selReportOpt.id)
    columnDefs = columnDefs.map(col => ({ ...col, isMandatory: intCompanyID === GUJRAT_COMPANY_ID ? false : col.isMandatory }))
    if (selReportView.id === 1) {
      if (reportData.length === 0 && reportDat1.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }
      mainReportData = cityWiseGroup(reportData, reportDat1, columnDefs, criteriaData)
      columnDefs = columnDefs.map((obj) => ({
        ...obj,
        export: obj.exportHead,
        align: obj.xlCol.dataType === 'quantity' ? 'right' : "left",
        weight: Number(obj.minWidth.replace('px', ''))
      }))
    } else {
      const summarySourceData = isBookedReceivedPendingDispatch() ? [...reportData, ...reportDat1] : reportData

      if (summarySourceData.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }
      columnDefs = columnDefs.map((obj) => ({
        ...obj,
        export: obj.exportHead,
        align: obj.xlCol.dataType === 'quantity' ? 'right' : "left",
        weight: 80
      }))
      if (selReportOpt.id === 1) {
        mainReportData = paymentSummaryData(summarySourceData, columnDefs, criteriaData)
      }
      if (selReportOpt.id === 2) {
        mainReportData = branchSummaryData(summarySourceData, columnDefs, criteriaData)
      }
      if (Number(selReportOpt.id) === 3) {
        mainReportData = statusWiseSummaryData(summarySourceData, columnDefs, criteriaData, selectedStatusWiseHeaders)
      }
    }

    if (Array.isArray(mainReportData) && mainReportData.length && intCompanyID === GUJRAT_COMPANY_ID) {
      const lastIndex = mainReportData.length - 1
      mainReportData = mainReportData.filter(
        (row, index) => row?.dataType !== 'subHeader' && (row?.dataType !== 'total' || index === lastIndex)
      ).map((row, index) => ({ ...row, srNo: row?.dataType === 'entry' ? index + 1 : row.srNo }))

    }



  
    const reportPayload = {
      reportName,
      criteriaHeaders: criteriaHeaders,
      criteriaData: [criteriaData],
      tableData: mainReportData,
      mainHeader: columnDefs,
      isShowManageColumn: selReportView.id === 1,
      manageColumnID: 'LRWiseDetailsStatusReport339',
      hideHeader: selReportView.id === 0 && selReportOpt.id === 3,
      colSpanMarker: selReportView.id === 1 ? 'BookedByUser' : '',
      totalSubKey: selReportView.id === 1 ? 4 : 0,
      serialNokey: selReportView.id === 1 ? "srNo" : selReportOpt.id === 1 || selReportOpt.id === 3 ? 'sNo' : selReportOpt.id === 2 ? 'srNo' : '',
      tableStyle: selReportView.id === 1 ? { tableLayout: 'fixed', width: 'max-content' } : {},
      showColumnBorders: true,
    }
    if (isPdf === true) {
      downloadPDF({
        reportName,
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: mainReportData,
        visibleColumns: columnDefs,
        loginData,
        hideHeader: selReportView.id === 0 && selReportOpt.id === 3,
        showColumnBorders: true,
      })
      return
    }
    const rid = Date.now().toString()

    if (!window.generatedReports) {
      window.generatedReports = {}
    }

    window.generatedReports[rid] = reportPayload

    window.open(`/view-report?rid=${rid}`, "_blank")

  }

  const getNonMovementData = async (body) => {
    setLoader(true)
    try {
      const res = await GetRequest(urls.getCargoNonMovedDetails, body)
      if (res?.status !== 'Success') {
        throw new Error(res?.ErrMessage || 'Request Failed')
      }
      const { Table = [], Table1 = [], Table3 = [] } = res?.Data || {}
      let sourceList = []
      const isPrimaryView = !!selReportView?.id || selReportOpt?.id === 2 || selReportOpt?.id === 3 || selReportOpt?.id === 4
      if (isDestinationWiseSummary) {
        sourceList = Array.isArray(Table3) ? Table3 : []
      } else {
        if (!Array.isArray(Table) || !Array.isArray(Table1)) {
          throw new Error('Invalid Response Structure')
        }
        sourceList = isPrimaryView ? Table : Table1
      }
      if (sourceList.length === 0) {
        return []
      }
      const sourceList2 = sourceList
        .map((item, index) => {
          const bookingMoment = item.BookingDateTime ? moment(item.BookingDateTime) : null
          const bookingDate = bookingMoment ? bookingMoment.format('DD-MMM-YYYY') : ''
          const bookingTime = bookingMoment ? bookingMoment.format('hh:mm A') : ''
          return {
            ...item,
            srNo: index + 1,
            BookingDate: bookingDate,
            BookingTime: bookingTime,
          }
        })
        .map((item) => ({ ...item, ...buildCompositeFields(item, manageColumn) }))
      const paymentRule = isPrimaryView ? TOPAY_COD_RULE : TOPAY_COD_RULE2
      const finalData =
        UseToPayAsCOD !== 1
          ? sourceList2
          : sourceList2.map((item) => ({
            ...item,
            PaymentType: paymentRule[item.PaymentTypeID + ''] ?? item.PaymentType,
          }))

      return finalData
    } catch (err) {
      setAlert({ show: true, msg: err.message, nextId: '' })
      return []
    } finally {
      setLoader(false)
    }
  }

  // Generate Financial Years
  function generateFinancialYears(count) {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()
    const currentYear = month >= 3 ? year : year - 1
    const financialYears = []
    const increment = month >= 3 ? 1 : 2
    for (let i = 0; i < count; i++) {
      const startYear = currentYear - i
      const endYear = startYear + 1
      const financialYear = `${startYear}-${String(endYear).slice(-2)}`
      financialYears.push({ id: i + increment, name: financialYear })
    }
    return financialYears
  }
  useEffect(() => {
    let finYears = generateFinancialYears(3)
    setSelfinancialYear(finYears[0])
    setFinYearsOpt(finYears)
  }, [])
  let cityOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentCityID').filter(
    (obj) => obj.CurrentStateID == selState?.CurrentStateID || selState?.CurrentStateID == 0
  )
  let stateOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentStateID')
  let branchOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentBranchID').filter((obj) =>
    selCity?.CurrentCityID !== 0
      ? obj.CurrentCityID == selCity?.CurrentCityID
      : selState?.CurrentStateID == 0
        ? true
        : obj.CurrentStateID === selState?.CurrentStateID
  )

  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  const reset = () => {
    setResetFlag(!resetFlag)
    setIsBranchWise(false)
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setNmDays(4)
    setSelCity('')
    setSelBranch('')
    setSelState('')
    setselReportView(MovementReportView[1])
    setSelReportOpt(detailedReport[0])
    setSelCrosssingTrans(crossingTransactions[1])
    setSelLRStatus(excludingCrossing[0])
    setSelTransaction(showTransaction[1])
    setNonMoveFilterData([])
  }
  useEffect(() => {
    focusElemnt(id.financialYear)
  }, [])
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('LRWiseDetailsStatusReport339', JSON.stringify(item))
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={id.selectCompnay}
                label={lb.select_company}
                defaultvalue={strCompanyName}
                disabled={true}
                minWidth="300px"
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                GO
              </Button>
            </Item>
          </>}
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.financialYear}
              label={lb.financialYear}
              disabled={isBranchWise}
              data={finYearsOpt}
              defaultvalue={selfinancialYear?.name}
              onSelect={setSelfinancialYear}
              idKey={`id`}
              dataKey={`name`}
              nextId={id.showTransaction}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.showTransaction}
              label={lb.showTransaction}
              data={showTransaction}
              defaultvalue={selTransaction?.name || selTransaction}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              onSelect={setSelTransaction}
              disabled={isBranchWise}
              searchPlaceholder={`Search Transaction`}
              prevId={id.financialYear}
              nextId={id.branchWiseCheck}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <FormControlLabel
              value="end"
              checked={isBranchWise}
              onChange={() => {
                setIsBranchWise(!isBranchWise)
                if (!isBranchWise) {
                  focusElemnt(id.fromDate)
                }
              }}
              onKeyDown={(e) => {
                navigation3(e, isBranchWise ? id.fromDate : 'filterGo', id.showTransaction, () => { })
              }}
              control={<Checkbox id={id.branchWiseCheck} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
                  {isFromUrl ? (
                    'Booking Date Wise'
                  ) : (
                    <>
                      Booking
                      <br />
                      Date Wise
                    </>
                  )}
                </Typography>
              }
              labelPlacement="end"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.fromBookingDate}
              width="100%"
              name={'from_Booking_Date'}
              id={id.fromDate}
              value={fromDate}
              statusChecked={!isBranchWise}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
              <Datepicker
                label={lb.toBookingDate}
                width="100%"
                name={'to_Booking_Date'}
                id={id.toDate}
                value={toDate}
                statusChecked={!isBranchWise}
                dateChange={(date) => {
                  setToDate(date)
                  focusElemnt('filterGo')
                }}
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                id="filterGo"
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                onKeyDown={(e) => {
                  navigation3(e, id.stateId, isBranchWise ? id.toDate : id.branchWiseCheck, () => {
                    handleFilterData()
                  })
                }}
                onClick={handleFilterData}
              >
                GO
              </Button>
            </Item>
          </Box>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={lb.selectState}
              defaultvalue={selState?.CurrentStateName || selState}
              value={selState?.CurrentStateName || selState}
              data={stateOption.length > 0 ? [{ CurrentStateName: 'All State', CurrentStateID: 0 }, ...stateOption] : stateOption}
              dataKey={`CurrentStateName`}
              idKey={`CurrentStateID`}
              onSelect={handleStateChange}
              isObjArr={true}
              searchPlaceholder={`Search State`}
              disabled={
                !(
                  AllowViewAllBranchReport ||
                  IsBranchAdmin ||
                  IsMTPLAdmin ||
                  IsAdmin
                )
              }
              resetFlag={resetFlag}
              prevId={'filterGo'}
              nextId={id.cityId}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.cityId}
              label={lb.selectCity}
              isObjArr={true}
              onSelect={handleCityChange}
              defaultvalue={selCity?.CurrentCity || selCity}
              value={selCity?.CurrentCity || selCity}
              data={nonMoveFilterData.length > 0 ? [{ CurrentCity: 'All City', CurrentCityID: 0 }, ...cityOption] : cityOption}
              dataKey={`CurrentCity`}
              idKey={`CurrentCityID`}
              searchPlaceholder={`Search City`}
              disabled={
                !(
                  AllowViewAllBranchReport ||
                  IsBranchAdmin ||
                  IsMTPLAdmin ||
                  IsAdmin
                )
              }
              resetFlag={resetFlag}
              prevId={id.stateId}
              nextId={id.selectBranch}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.selectBranch}
              label={lb.selectBranch}
              defaultvalue={selBranch?.CurrentBranch || selBranch}
              value={selBranch?.CurrentBranch || selBranch}
              isObjArr={true}
              onSelect={setSelBranch}
              data={branchOption.length > 0 ? [{ CurrentBranch: 'All Branch', CurrentBranchID: 0 }, ...branchOption] : branchOption}
              dataKey={`CurrentBranch`}
              idKey={`CurrentBranchID`}
              disabled={
                !(
                  AllowViewAllBranchReport ||
                  IsBranchAdmin ||
                  IsMTPLAdmin ||
                  IsAdmin
                ) && AllowViewAllBranchOfCityReport == 0
              }
              searchPlaceholder={`Search Branch`}
              resetFlag={resetFlag}
              prevId={id.cityId}
              nextId={id.SelectDays}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownMultiSelect
              label={lb.paymentType}
              id={id.paymentType}
              data={updatedPaymentModes}
              searchPlaceholder={`Search By Payment`}
              HasAllSelect={true}
              dataKey={`name`}
              defaultvalue={updatedPaymentModes}
              idKey={`typeId`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
              prevId={id.selectBranch}
              nextId={id.SelectDays}
              width="100%"
            />
          </Item>
          {!isFromUrl && (
            <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
              <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
                Not Moved
                <br />
                Since Days
              </Typography>
            </Item>
          )}
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDown
              id={id.SelectDays}
              label={isFromUrl ? 'Not Moved Since Days' : lb.SelectDays}
              data={nmrDays}
              onSelect={(val) => {
                setShowReport(false)
                setNmDays(val)
              }}
              defaultvalue={nmDays || '0'}
              value={nmDays || '0'}
              searchPlaceholder={`Search Days`}
              width={isFromUrl ? '100%' : '110px'}
              prevId={id.selectBranch}
              nextId={id.reportView}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.reportView}
              label={lb.reportView}
              data={MovementReportView}
              defaultvalue={selReportView?.name || selReportView}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setShowReport(false)
                setselReportView(val)
                if (val.id) {
                  setSelReportOpt(detailedReport[0])
                } else {
                  setSelReportOpt(summaryReport[0])
                }
                if (isGtCompany && ['BRW', 'DW'].includes(String(selLRStatus?.id).toUpperCase())) {
                  setSelLRStatus(excludingCrossing[0])
                }
              }}
              isObjArr={true}
              searchPlaceholder={`Search Report`}
              prevId={id.SelectDays}
              nextId={id.ReportOptions}
              width="100%"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.ReportOptions}
              label={lb.ReportOptions}
              defaultvalue={selReportOpt?.name || selReportOpt}
              data={selReportView.id ? detailedReport : summaryReportOptions}
              onSelect={(val) => {
                setShowReport(false)
                setSelReportOpt(val)
                if (Number(val.id) === 4 && Number(selReportView.id) === 0) {
                  setSelCrosssingTrans(crossingTransactions[0])
                  setSelLRStatus(brwOption)
                } else if (Number(val.id) === 5 && Number(selReportView.id) === 0) {
                  setSelCrosssingTrans(crossingTransactions[0])
                  setSelLRStatus(dwOption)
                } else {
                  if (isGtCompany && ['BRW', 'DW'].includes(String(selLRStatus?.id).toUpperCase())) {
                    setSelLRStatus(excludingCrossing[0])
                  }
                  if (val.id === 3 && selReportView.id === 0) {
                    setSelCrosssingTrans(crossingTransactions[0])
                  }
                }
              }}
              isObjArr={true}
              idKey={`id`}
              dataKey={`name`}
              searchPlaceholder={`Search Report`}
              prevId={id.reportView}
              nextId={id.crossingTransactions}
              width="100%"
            />
          </Item>

          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.crossingTransactions}
              label={lb.crossingTransactions}
              defaultvalue={selCrossingTrans?.name || selCrossingTrans}
              data={crossingTransactions}
              disabled={isLockedPendingDispatchSummary}
              onSelect={(val) => {
                setShowReport(false)
                setSelCrosssingTrans(val)
                if (val.id) {
                  setSelLRStatus(includingCrossingLocal[0])
                } else {
                  setSelLRStatus(excludingCrossing[0])
                }
              }}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              width={isFromUrl ? '100%' : '250px'}
              searchPlaceholder={`Search Crossig Transaction`}
              prevId={id.ReportOptions}
              nextId={id.status}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.status}
              label={lb.LRStatus}
              defaultvalue={selLRStatus?.name || selLRStatus}
              data={lrStatusOptions}
              disabled={isLockedPendingDispatchSummary}
              onSelect={(val) => {
                setShowReport(false)
                setSelLRStatus(val)
              }}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              width={isFromUrl ? '100%' : '330px'}
              searchPlaceholder={`Search LRStatus`}
              prevId={id.crossingTransactions}
              nextId={id.reportmainButton}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => generateNonMovementReport(true)} id1={id.reportmainButton}>
              DOWNLOAD PDF
            </Button> : <>
              <Item
                sx={sx.itemsx}
                onKeyDown={(e) => {
                  navigation3(
                    e,
                    showReport
                      ? isPdfLoading
                        ? 'backBtn'
                        : disableExcel
                          ? 'exportPdf'
                          : 'exportExcelBtn'
                      : isBranchWise
                        ? id.fromDate
                        : id.financialYear,
                    id.status,
                    () => {
                      generateNonMovementReport()
                    }
                  )
                }}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  onClick1={generateNonMovementReport}
                  onClick2={handleClick1}
                  hideToggle={isBookedReceivedPendingDispatch() || isDestinationWiseSummary}
                  id1={id.reportmainButton}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} onClick={reset}>
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
      {mdt.LRWiseDetailsReport === modal ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} /> : null}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnChildBranches, getNonMovementFilterData, getBranchConfig, updateLoader, updateModal }

export default connect(mapStateToProps, mapDispatchToProps)(NonMovementReport)
